export const HOME = '/';

export const HOME_SCREEN = '/home';

export const REPORTS = '/reports';
export const SINGLE_REPORT = '/reports/:reportId';
export const MY_REPORTS = '/my-reports';
export const SINGLE_MY_REPORT = '/my-reports/:reportId';
export const AI_CHAT = '/ai-chat';
export const AI_CHAT_THREAD = '/ai-chat/:threadId';
export const AI_REPORTS = '/ai-reports';
export const AI_REPORTS_EDIT = '/ai-reports/:reportId';

export const SUMMARY = '/key-metrics';
export const CAMPAIGNS = '/campaigns';
export const SINGLE_CAMPAIGN = '/campaigns/:campaignId';
export const HEATMAPS = '/heatmaps';
export const CAMERA_PREVIEW = '/camera-preview';
export const EXPLORER = '/explorer';
export const HEADCOUNT_PLANNER = '/headcount-planner';

export const LIVE_OCC = '/live';

export const LOGIN = '/login';
export const LOGOUT = '/logout';

export const SETTINGS = '/settings';
export const SETTINGS_USERS = '/settings/users';
export const SETTINGS_TOOLS = '/settings/tools';
export const SETTINGS_MANAGE_LOCATIONS = '/settings/manage/locations';

export const SETTINGS_MANAGE_SINGLE_LOCATION = '/settings/manage/location';
export const SETTINGS_MANAGE_SINGLE_CAMERA_SERVER = '/settings/manage/camera-server';
export const SETTINGS_MANAGE_SINGLE_RECORDING = '/settings/manage/camera';

export const TRAINING = '/training';

export const VIEW_TOKEN = '/token';
